module.exports = __webpack_public_path__ + "img/BS_crosshairs_A.ad1929a2.svg";